module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_21.87321bd0.jpg";